import {
  CheckOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
  ClockCircleFilled,
} from "@ant-design/icons";
import { Button, Tag } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { colors } from "../theme/colors";

export const components = {
  header: {
    cell: ({ style, ...restProps }) => (
      <th
        {...restProps}
        style={{
          ...style,
          backgroundColor: "#000a7b",
          color: "#fff",
        }}
      />
    ),
  },
};

// export const components = {
//   header: {
//     cell: ({ style, ...restProps }) => (
//       <th
//         {...restProps}
//         style={{
//           ...style,
//           backgroundColor: '#000a7b',
//           color: '#fff',
//         }}
//       />
//     ),
//   },
//   body: {
//     cell: ({ style, ...restProps }) => (
//       <td
//         {...restProps}
//         style={{
//           ...style,
//           padding: '8px', // Adjust padding here
//         }}
//       />
//     ),
//     // row: ({ children, ...restProps }) => (
//     //   <tr {...restProps}>
//     //     {React.Children.map(children, (child) => (
//     //       <td {...child.props}>
//     //         <div style={{ marginBottom: '10px' }}>{child.props.children}</div>
//     //       </td>
//     //     ))}
//     //   </tr>
//     // ),

//   }
// };

// Distributor
export const dataDistributors = [
  {
    key: 1,
    distributor: "Integrity Medical Consultants",
    accounts: 22,
    salesYTD: "$23,389",
    activeYTD: 22,
    salesMTD: "$23,389",
    activeMTD: 22,
  },
  {
    key: 2,
    distributor: "Gatlin Group Consulting",
    accounts: 22,
    salesYTD: "$23,389",
    activeYTD: 22,
    salesMTD: "$23,389",
    activeMTD: 22,
  },
  ...Array.from({ length: 10 }, (_, i) => ({
    key: i + 3,
    distributor: "Blue Medical LLC",
    accounts: 22,
    salesYTD: "$23,389",
    activeYTD: 22,
    salesMTD: "$23,389",
    activeMTD: 22,
  })),
];

export const columnsDistributors = [
  {
    title: "Distributor",
    dataIndex: "distributor",
    key: "distributor",
    sorter: (a, b) => a.distributor.localeCompare(b.distributor),
  },
  {
    title: "Accounts",
    dataIndex: "accounts",
    key: "accounts",
    sorter: (a, b) => a.accounts - b.accounts,
  },
  {
    title: "Sales YTD",
    dataIndex: "salesYTD",
    key: "salesYTD",
    sorter: (a, b) =>
      parseFloat(a.salesYTD.replace(/[^0-9.-]+/g, "")) -
      parseFloat(b.salesYTD.replace(/[^0-9.-]+/g, "")),
  },
  {
    title: "Active YTD",
    dataIndex: "activeYTD",
    key: "activeYTD",
    sorter: (a, b) => a.activeYTD - b.activeYTD,
  },
  {
    title: "Sales MTD",
    dataIndex: "salesMTD",
    key: "salesMTD",
    sorter: (a, b) =>
      parseFloat(a.salesMTD.replace(/[^0-9.-]+/g, "")) -
      parseFloat(b.salesMTD.replace(/[^0-9.-]+/g, "")),
  },
  {
    title: "Active MTD",
    dataIndex: "activeMTD",
    key: "activeMTD",
    sorter: (a, b) => a.activeMTD - b.activeMTD,
  },
  {
    title: "Action",
    key: "action",
    align: "end",
    render: () => (
      <Button
        type="primary"
        style={{ background: "#ff9202" }}
        href="/DistributorDetails"
      >
        View
      </Button>
    ),
  },
];

// Distributor Home
export const dataDistributorHome = [
  {
    key: 1,
    invoice: 133156,
    orderDate: "March 28th, 2024",
    dueDate: "April 15th, 2024",
    dueIn: "Past Due",
    accountName: "Home Heal",
    manufacturer: "Skye Biologics",
    total: "$23,389",
    openBalance: "$3,389",
  },
  {
    key: 2,
    invoice: 133156,
    orderDate: "March 28th, 2024",
    dueDate: "April 28th, 2024",
    dueIn: "13 Days",
    accountName: "Home Heal",
    manufacturer: "Defender",
    total: "$23,389",
    openBalance: "$2,489",
  },
  ...Array.from({ length: 10 }, (_, i) => ({
    key: i + 3,
    invoice: 133156,
    orderDate: "March 28th, 2024",
    dueDate: "May 28th, 2024",
    dueIn: "44 Days",
    accountName: "Home Heal",
    manufacturer: "Defender",
    total: "$23,389",
    openBalance: "$2,489",
  })),
];

export const columnsDistributorHome = [
  {
    title: "Invoice",
    dataIndex: "invoice",
    key: "invoice",
    //   sorter: (a, b) => a.distributor.localeCompare(b.distributor),
  },
  {
    title: "Order Date",
    dataIndex: "orderDate",
    key: "orderDate",
    //   sorter: (a, b) => a.accounts - b.accounts,
  },
  {
    title: "Due Date",
    dataIndex: "dueDate",
    key: "dueDate",
    //   sorter: (a, b) => parseFloat(a.salesYTD.replace(/[^0-9.-]+/g, "")) - parseFloat(b.salesYTD.replace(/[^0-9.-]+/g, "")),
  },
  {
    title: "Due In",
    dataIndex: "dueIn",
    key: "dueIn",
    //   sorter: (a, b) => a.activeYTD - b.activeYTD,
  },
  {
    title: "Account Name",
    dataIndex: "accountName",
    key: "accountName",
    //   sorter: (a, b) => parseFloat(a.salesMTD.replace(/[^0-9.-]+/g, "")) - parseFloat(b.salesMTD.replace(/[^0-9.-]+/g, "")),
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer",
    key: "manufacturer",
    //   sorter: (a, b) => a.activeMTD - b.activeMTD,
  },
  {
    title: "Total",
    dataIndex: "total",
    key: "total",
    //   sorter: (a, b) => a.activeMTD - b.activeMTD,
  },
  {
    title: "Open Balance",
    dataIndex: "openBalance",
    key: "openBalance",
    //   sorter: (a, b) => a.activeMTD - b.activeMTD,
  },
  {
    title: "Action",
    key: "action",
    align: "end",
    render: () => (
      <Button type="primary" style={{ background: "#ff9202" }}>
        View
      </Button>
    ),
  },
];

// Distributor Details Accounts
export const dataDistributorDetailsAccounts = [
  {
    key: 1,
    accountName: "A New You Wellness Center LLC",
  },
  {
    key: 2,
    accountName: "ABBA Gentle Healthcare",
  },
  {
    key: 3,
    accountName: "Aderholt Medical",
  },
  {
    key: 4,
    accountName: "Advanced Footcare Center",
  },
  {
    key: 5,
    accountName: "Home Heal",
  },
  {
    key: 6,
    accountName: "Home Heal",
  },
  {
    key: 7,
    accountName: "Pro Medical Health Solutions, Inc",
  },
];

export const columnsDistributorDetailsAccounts = [
  {
    title: "Account Name",
    dataIndex: "accountName",
    key: "accountName",
    sorter: (a, b) => a.distributor.localeCompare(b.distributor),
  },
  {
    title: "Actions",
    key: "actions",
    align: "end",
    render: () => (
      <Button type="primary" style={{ background: "#ff9202" }}>
        View
      </Button>
    ),
  },
];

// Distributor Details Users
export const dataDistributorDetailsUsers = [
  {
    key: 1,
    name: "James Brown",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: 2,
    name: "Lauren Brown",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: 3,
    name: "Another Person",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
];

export const columnsDistributorsDetailsUsers = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.distributor.localeCompare(b.distributor),
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    sorter: (a, b) => a.distributor.localeCompare(b.distributor),
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    sorter: (a, b) => a.distributor.localeCompare(b.distributor),
  },
  {
    title: "Action",
    key: "action",
    align: "end",
    render: () => (
      <Button type="primary" style={{ background: "#ff9202" }}>
        View
      </Button>
    ),
  },
];

// Approvals
export const dataApprovals = [
  {
    key: 1,
    orderDate: "March 18th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Home Heal",
    manufacturer: "Skye Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
  {
    key: 2,
    orderDate: "March 19th, 2024",
    poNumber: "CO011824SUSWOO#3(15)",
    accountName: "ABBA Gentle Healthcare",
    manufacturer: "Defender",
    orderType: "Consignment Order",
    total: "$23,389",
  },
  {
    key: 3,
    orderDate: "March 20th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Aderholt Medical",
    manufacturer: "ExtrimityCare",
    orderType: "Product Usage",
    total: "$23,389",
  },
  {
    key: 4,
    orderDate: "March 20th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Advanced Foot Care Center",
    manufacturer: "Royal Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
  {
    key: 5,
    orderDate: "March 21st, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Chevy Chase Foot & Ankle",
    manufacturer: "Skye Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
  {
    key: 6,
    orderDate: "March 28th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Home Heal",
    manufacturer: "Skye Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
  {
    key: 7,
    orderDate: "March 28th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Pro Medical Health Solutions, Inc",
    manufacturer: "Skye Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
  {
    key: 8,
    orderDate: "March 18th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Home Heal",
    manufacturer: "Skye Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
  {
    key: 9,
    orderDate: "March 18th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Home Heal",
    manufacturer: "Skye Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
  {
    key: 10,
    orderDate: "March 18th, 2024",
    poNumber: "PO011824SUSWOO#3(15)",
    accountName: "Home Heal",
    manufacturer: "Skye Biologics",
    orderType: "Direct Order",
    total: "$23,389",
  },
];

export const columnsApprovals = (openModal) => [
  {
    title: "Order Date",
    dataIndex: "orderDate",
    key: "orderDate",
  },
  {
    title: "PO Number",
    dataIndex: "poNumber",
    key: "poNumber",
  },
  {
    title: "Account Name",
    dataIndex: "accountName",
    key: "accountName",
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer",
    key: "manufacturer",
  },
  {
    title: "Order Type",
    dataIndex: "orderType",
    key: "orderType",
  },
  {
    title: "Total",
    dataIndex: "total",
    key: "total",
  },
  {
    title: "Action",
    key: "action",
    render: (text, record) => (
      <div style={{ display: "flex", gap: "8px" }}>
        <Button type="primary" style={{ background: "#ff9202" }}>
          View
        </Button>
        <Button
          type="primary"
          style={{ background: "#27a907" }}
          icon={<CheckOutlined />}
          onClick={() => openModal(record)}
        >
          Approve
        </Button>
      </div>
    ),
  },
];

//Accounts
export const dataAccounts = [
  {
    key: 1,
    accountName: "A New You Wellness Center LLC",
    distributor: "House",
    region: "Northeast",
    ordersYTD: "23",
    salesYTD: "$23,389",
    openBalance: "$23,389",
    pastDue: "$23,389",
  },
  {
    key: 2,
    accountName: "ABBA General Healthcare",
    distributor: "Lamont West",
    region: "Southeast",
    ordersYTD: "23",
    salesYTD: "$23,389",
    openBalance: "$23,389",
    pastDue: "$23,389",
  },
  {
    key: 3,
    accountName: "Aderholt Medical",
    distributor: "Integrity Medical Consultants",
    region: "Southwest",
    ordersYTD: "23",
    salesYTD: "$23,389",
    openBalance: "$23,389",
    pastDue: "$23,389",
  },
  ...Array.from({ length: 10 }, (_, i) => ({
    key: i + 4,
    accountName: "Advanced Foot Care Center",
    distributor: "House",
    region: "Midwest",
    ordersYTD: "23",
    salesYTD: "$23,389",
    openBalance: "$23,389",
    pastDue: "$23,389",
  })),
];

export const columnsAccounts = [
  {
    title: "Account Name",
    dataIndex: "accountName",
    key: "accountName",
    //   sorter: (a, b) => a.distributor.localeCompare(b.distributor),
  },
  {
    title: "Distributor",
    dataIndex: "distributor",
    key: "distributor",
    //   sorter: (a, b) => a.accounts - b.accounts,
  },
  {
    title: "Region",
    dataIndex: "region",
    key: "region",
    //   sorter: (a, b) => parseFloat(a.salesYTD.replace(/[^0-9.-]+/g, "")) - parseFloat(b.salesYTD.replace(/[^0-9.-]+/g, "")),
  },
  {
    title: "Orders YTD",
    dataIndex: "ordersYTD",
    key: "dueIn",
    //   sorter: (a, b) => a.activeYTD - b.activeYTD,
  },
  {
    title: "Sales YTD",
    dataIndex: "salesYTD",
    key: "salesYTD",
    //   sorter: (a, b) => parseFloat(a.salesMTD.replace(/[^0-9.-]+/g, "")) - parseFloat(b.salesMTD.replace(/[^0-9.-]+/g, "")),
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer",
    key: "manufacturer",
    //   sorter: (a, b) => a.activeMTD - b.activeMTD,
  },
  {
    title: "Open Balance",
    dataIndex: "openBalance",
    key: "openBalance",
    //   sorter: (a, b) => a.activeMTD - b.activeMTD,
  },
  {
    title: "Past Due",
    dataIndex: "pastDue",
    key: "pastDue",
    //   sorter: (a, b) => a.activeMTD - b.activeMTD,
  },
  {
    title: "Action",
    key: "action",
    align: "end",
    render: () => (
      <Button
        type="primary"
        style={{ background: "#ff9202" }}
        href="/AccountDetails"
      >
        View
      </Button>
    ),
  },
];

export const dataAccountUsers = [
  {
    key: 1,
    name: "James Brown",
    role: ["TV User"],
    account: "Home Heal",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
    notes: "This is an example note.",
  },
  {
    key: 2,
    name: "Lauren Brown",
    role: ["TV User"],
    account: "Home Heal",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
    notes: "This is an example note.",
  },
  {
    key: 1,
    name: "James Brown",
    role: ["Contact"],
    account: "Home Heal",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
    notes: "This is an example note.",
  },
];

export const columnsAccountUsers = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    render: (_, { role }) => (
      <>
        {role.map((rl) => {
          let color;
          if (rl === "TV User") {
            color = "blue";
          }
          if (rl === "Contact") {
            color = "yellow";
          }
          return (
            <Tag color={color} key={rl}>
              {rl}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: "Account",
    dataIndex: "account",
    key: "account",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Notes",
    dataIndex: "notes",
    key: "notes",
  },
  {
    title: "Action",
    key: "action",
    align: "end",
    render: () => (
      <Button type="primary" style={{ background: "#ff9202" }}>
        View
      </Button>
    ),
  },
];

// Invoice
export const dataInvoice = [
  {
    key: "1",
    invoice: "133156",
    poNumber: "PO011824SUSWOO#3(15)",
    invoiceDate: "March 28th, 2024",
    dueDate: "March 29th, 2024",
    accountName: "Home Heal",
    manufacturer: "Skye Biologics",
    total: "$23,389",
    status: "paid",
  },
  {
    key: "2",
    invoice: "133156",
    poNumber: "PO011824SUSWOO#3(15)",
    invoiceDate: "March 28th, 2024",
    dueDate: "April 15th, 2024",
    accountName: "ABBA Gentle Healthcare",
    manufacturer: "Defender",
    total: "$23,389",
    status: "pending",
  },
  {
    key: "3",
    invoice: "133156",
    poNumber: "PO011824SUSWOO#3(15)",
    invoiceDate: "March 28th, 2024",
    dueDate: "April 15th, 2024",
    accountName: "Aderholt Medical",
    manufacturer: "ExtremityCare",
    total: "$23,389",
    status: "overdue",
  },
  // Add more rows as needed
];

export const columnsInvoice = [
  {
    title: "",
    dataIndex: "status",
    key: "status",
    render: (status) => {
      if (status === "paid") {
        return <CheckCircleFilled style={{ color: "#27a907" }} />;
      } else if (status === "overdue") {
        return <ExclamationCircleFilled style={{ color: "#ff0000" }} />;
      } else {
        return <ClockCircleFilled style={{ color: "#ff9202" }} />;
      }
    },
  },
  {
    title: "Invoice",
    dataIndex: "invoice",
    key: "invoice",
  },
  {
    title: "PO Number",
    dataIndex: "poNumber",
    key: "poNumber",
  },
  {
    title: "Invoice Date",
    dataIndex: "invoiceDate",
    key: "invoiceDate",
  },
  {
    title: "Due Date",
    dataIndex: "dueDate",
    key: "dueDate",
  },
  {
    title: "Account Name",
    dataIndex: "accountName",
    key: "accountName",
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer",
    key: "manufacturer",
  },
  {
    title: "Total",
    dataIndex: "total",
    key: "total",
  },
  {
    title: "Action",
    key: "action",
    render: () => (
      <Button
        type="primary"
        style={{ background: "#ff9202" }}
        href="/InvoiceView"
      >
        View
      </Button>
    ),
  },
];

// Users
export const dataUsers = [
  {
    key: "1",
    name: "User",
    status: "Home Heal",
    account: "Home Heal",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "2",
    name: "Teresa Etter",
    status: "A New You Wellness Center LLC",
    account: "A New You Wellness Center LLC",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "3",
    name: "Tyler Baum",
    status: "ABBA Gentle Healthcare",
    account: "ABBA Gentle Healthcare",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "4",
    name: "Daniel Kent",
    status: "Aderholt Medical",
    account: "Aderholt Medical",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "5",
    name: "Gabriel Dietrich",
    status: "Advanced Foot Care Center",
    account: "Advanced Foot Care Center",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "6",
    name: "Jonathan Sharp",
    status: "Americare Solutions LLC",
    account: "Americare Solutions LLC",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "7",
    name: "Sophia Matsangakis",
    status: "Associates In Dermatology",
    account: "Associates In Dermatology",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "8",
    name: "Jae Mercier",
    status: "Chevy Chase Foot & Ankle",
    account: "Chevy Chase Foot & Ankle",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "9",
    name: "Taylor Saffire",
    status: "Cocoa Urology Associates",
    account: "Cocoa Urology Associates",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "10",
    name: "Matt Eisenberg",
    status: "Dermatology Solutions",
    account: "Dermatology Solutions",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "11",
    name: "Kara Stoughton",
    status: "Harris Foot & Ankle",
    account: "Harris Foot & Ankle",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
];

export const columnsUsers = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Account",
    dataIndex: "account",
    key: "account",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
  },
  {
    title: "Action",
    key: "action",
    render: () => (
      <Button
        type="primary"
        style={{ background: "#ff9202" }}
        href="/UserDetails"
      >
        View
      </Button>
    ),
  },
];

// AS Users
export const dataASUsers = [
  {
    key: "1",
    name: "User",
    role: "Admin",
    region: "",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "2",
    name: "Teresa Etter",
    role: "Admin",
    region: "",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "3",
    name: "Tyler Baum",
    role: "Admin",
    region: "",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "4",
    name: "Daniel Kent",
    role: "Authorizer",
    region: "",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "5",
    name: "Gabriel Dietrich",
    role: "Authorizer",
    region: "",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "6",
    name: "Jonathan Sharp",
    role: "Authorizer",
    region: "",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "7",
    name: "Sophia Matsangakis",
    role: "Authorizer",
    region: "",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "8",
    name: "Jae Mercier",
    role: "ASD",
    region: "Southeast",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "9",
    name: "Taylor Saffire",
    role: "ASD",
    region: "Midwest",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "10",
    name: "Matt Eisenberg",
    role: "ASD",
    region: "Northeast",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
  {
    key: "11",
    name: "Kara Stoughton",
    role: "ASD",
    region: "Southwest",
    email: "email@advancedsolution.com",
    phone: "(223)-336-4644",
  },
];

export const columnsASUsers = [
  {
    title: "Name",
    dataIndex: "FirstName",
    key: "FirstName",
  },
  {
    title: "Role",
    dataIndex: "RoleType",
    key: "RoleType",
    render: (role) => (
      <Button
        type="default"
        shape="round"
        size="small"
        style={{
          color: colors["primaryColor"],
          borderColor: colors["primaryColor"],
          width: "100%",
        }}
      >
        {role}
      </Button>
    ),
  },
  {
    title: "Region",
    dataIndex: "RegionName",
    key: "RegionName",
    render: (region) =>
      region ? (
        <Button
          type="default"
          shape="round"
          size="small"
          style={{
            color: colors["primaryColor"],
            borderColor: colors["primaryColor"],
            width: "100%",
          }}
        >
          {region}
        </Button>
      ) : null,
  },
  {
    title: "Email",
    dataIndex: "Email",
    key: "Email",
  },
  {
    title: "Phone",
    dataIndex: "Phone",
    key: "Phone",
  },
  {
    title: "Action",
    key: "action",
    render: (record) => (
      <Button type="primary" style={{ background: "#ff9202" }}>
        <Link to={`/ASUserDetails/${record.ID}`}>View</Link>
      </Button>
    ),
  },
];
